import React, { ReactElement } from "react";
//import * as PHIcon from "@phosphor-icons/react/dist/ssr";
import * as PHIcon from "./SSRIcon";
import { IconProps, IconWeight } from "@phosphor-icons/react/dist/lib/types";
import { Debug } from "@/util/debug";
//const PHIcon = require("@phosphor-icons/react/dist/ssr").default;
const iconList: string[] = [];
export interface PHIconProps extends IconProps {
  iconType: string;
  iconName: string;
  className?: string;
}
const PhIconKeyMap: { [key: string]: keyof typeof PHIcon } = {};
let k: keyof typeof PHIcon;
for (k in PHIcon) {
  PhIconKeyMap[k.toString()] = k;
}
const getPHIcon = (iconName: string) => {
  const Icon = PHIcon[PhIconKeyMap[iconName]];
  if (process.env.NODE_ENV !== "production" && Icon === undefined) {
    if (!iconList.includes(iconName)) {
      iconList.push(iconName);
    }
    Debug("Check Icon : " + iconList);
  }
  return Icon ?? PHIcon["Coffee"];
};
export const weights: Map<IconWeight, React.ReactElement<any, string | React.JSXElementConstructor<any>>> = {
  clear: function (): void {
    throw new Error("Function not implemented.");
  },
  delete: function (key: IconWeight): boolean {
    throw new Error("Function not implemented.");
  },
  forEach: function (
    callbackfn: (
      value: React.ReactElement<any, string | React.JSXElementConstructor<any>>,
      key: IconWeight,
      map: Map<IconWeight, React.ReactElement<any, string | React.JSXElementConstructor<any>>>,
    ) => void,
    thisArg?: any,
  ): void {
    throw new Error("Function not implemented.");
  },
  get: function (key: IconWeight): React.ReactElement<any, string | React.JSXElementConstructor<any>> | undefined {
    throw new Error("Function not implemented.");
  },
  has: function (key: IconWeight): boolean {
    throw new Error("Function not implemented.");
  },
  set: function (
    key: IconWeight,
    value: React.ReactElement<any, string | React.JSXElementConstructor<any>>,
  ): Map<IconWeight, React.ReactElement<any, string | React.JSXElementConstructor<any>>> {
    throw new Error("Function not implemented.");
  },
  size: 0,
  // entries: function (): IterableIterator<[IconWeight, React.ReactElement<any, string | React.JSXElementConstructor<any>>]> {
  //   throw new Error("Function not implemented.");
  // },
  // keys: function (): IterableIterator<IconWeight> {
  //   throw new Error("Function not implemented.");
  // },
  // values: function (): IterableIterator<React.ReactElement<any, string | React.JSXElementConstructor<any>>> {
  //   throw new Error("Function not implemented.");
  // },
  // [Symbol.iterator]: function (): IterableIterator<[IconWeight, React.ReactElement<any, string | React.JSXElementConstructor<any>>]> {
  //   throw new Error("Function not implemented.");
  // },
  // entries: function (): MapIterator<[IconWeight, React.ReactElement<any, string | React.JSXElementConstructor<any>>]> {
  //   throw new Error("Function not implemented.");
  // },
  // keys: function (): MapIterator<IconWeight> {
  //   throw new Error("Function not implemented.");
  // },
  // values: function (): MapIterator<React.ReactElement<any, string | React.JSXElementConstructor<any>>> {
  //   throw new Error("Function not implemented.");
  // },
  // [Symbol.iterator]: function (): MapIterator<[IconWeight, React.ReactElement<any, string | React.JSXElementConstructor<any>>]> {
  //   throw new Error("Function not implemented.");
  // }
  entries: function (): any {
    throw new Error("Function not implemented.");
  },
  keys: function (): any {
    throw new Error("Function not implemented.");
  },
  values: function (): any {
    throw new Error("Function not implemented.");
  },
  [Symbol.iterator]: function (): any {
    throw new Error("Function not implemented.");
  },
  [Symbol.toStringTag]: "",
};

export default function SSRIcon(iconProps: PHIconProps) {
  let Pi;
  switch (iconProps.iconType) {
    case "phosphor":
      Pi = getPHIcon(iconProps.iconName);
      break;
    default:
      Pi = getPHIcon(iconProps.iconName);
      break;
  }
  return (
    <Pi
      className={iconProps.className}
      alt={iconProps.alt}
      color={iconProps.color}
      size={iconProps.size}
      weight={iconProps.weight}
      mirrored={iconProps.mirrored}
      weights={weights}
    ></Pi>
  );
}
